import { trackableEvents } from "./trackable_events";

export const pathEvents = {
  sdp_sdp: trackableEvents.page.SDP,
  vdp_index: trackableEvents.page.VDP,
};
export const detectedPathEvent = () => {
  const path = document.body.dataset && document.body.dataset.path;
  if (pathEvents[path]) return pathEvents[path];
  return null;
};
